 
const ConsignmentActions = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
        // console.log("MAP Icon ", props)
        // props.context.componentParent.onCloseUploadDiv(e);
        // props.context.componentParent.onCloseRouteDiv(e);
        props.context.onShowOverspeedData(props);
    };

    return (
            <a onClick={handleRouteClick}  title="Overspeed"><i className="fa fa-tachometer f20"></i> </a>
        
    );
};

export default ConsignmentActions;
